import MuiBox from '@new-components/atoms/MuiBox';
import Image from '@new-components/atoms/Image';

import {MediaQuery} from '@constants/theme';

import {UserExperiences} from '@new-components/molecules/TestimonialsOnExperiences/types';

const TestimonialsImageSection = ({
  userExperiences,
}: {
  userExperiences: UserExperiences;
}): JSX.Element => {
  return (
    <>
      <MuiBox
        sx={{
          borderRadius: 6,
          position: 'relative',
          overflow: 'hidden',
          [MediaQuery.desktop]: {
            width: '50%',
            height: '500px',
          },
          [MediaQuery.mobile]: {
            width: '100%',
          },
        }}>
        <MuiBox
          sx={{
            position: 'relative',
            height: '100%',
            width: '100%',
            objectFit: 'cover',
            zIndex: 1,
            // ← consistent rectangular shape
            aspectRatio: '4 / 3',
            borderRadius: 6,
            overflow: 'hidden',
          }}>
          <Image
            src={userExperiences?.img}
            alt={userExperiences?.img}
            fill
            style={{objectFit: 'cover', zIndex: 1}}
          />
        </MuiBox>
      </MuiBox>
    </>
  );
};

export default TestimonialsImageSection;
